import './index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef, useState, useCallback, useEffect } from 'react';
import { useDebounce } from '@hh.ru/magritte-common-func-utils';
import { useMultipleRefs } from '@hh.ru/magritte-common-use-multiple-refs';
import { useBreakpoint } from '@hh.ru/magritte-ui-breakpoint';
import { SearchInput } from '@hh.ru/magritte-ui-input';
import { useAnimationTimeout } from './useAnimationTimeout.js';

const WrapperInput = forwardRef(({ parentRef, ...props }, ref) => {
    const multiRef = useMultipleRefs(ref, parentRef);
    return jsx(SearchInput, { ...props, ref: multiRef, "data-qa": "tree-selector-search-input" });
});
WrapperInput.displayName = 'TreeSelectorInput';
const useRenderInput = (inputRef) => {
    const [contentFilterQuery, setContentFilterQuery] = useState('');
    const { animationTimeout } = useAnimationTimeout();
    const [value, setValue] = useState('');
    const { isMobile } = useBreakpoint();
    const inputRefCallback = useCallback((node) => {
        if (!node) {
            setValue('');
            setContentFilterQuery('');
        }
    }, []);
    const ref = useMultipleRefs(inputRef, inputRefCallback);
    useEffect(() => {
        setValue('');
        setContentFilterQuery('');
    }, [isMobile]);
    const debouncedContentFilterQuery = useDebounce(useCallback((newValue) => {
        setContentFilterQuery(newValue);
    }, []), animationTimeout);
    const handleChangeInput = useCallback((newValue) => {
        debouncedContentFilterQuery(newValue);
        setValue(newValue);
    }, [debouncedContentFilterQuery]);
    const setInputValue = useCallback((newValue) => {
        setValue(newValue);
    }, [setValue]);
    const renderInput = useCallback((props) => {
        return jsx(WrapperInput, { ...props, value: value, onChange: handleChangeInput, parentRef: ref });
    }, [ref, value, handleChangeInput]);
    return { contentFilterQuery, setInputValue, handleChangeInput, renderInput };
};

export { useRenderInput };
//# sourceMappingURL=useRenderInput.js.map
